import React from 'react';
import { useSpacing } from '../../api/spacing/useSpacing';
import { pickDataProps, pickAriaProps, pickComponentCommonProps, } from '../../interfaces/commonProps';
import { StyledButton, StyledArrow, StyledIconContainer, StyledButtonLabel, } from './Button.styles';
import { buttonPropTypes } from './Button.types';
/**
 * Buttons can be used to show the user’s choice of options for actions and assign these to a clear hierarchy.
 */
export const Button = React.forwardRef(({ children, disabled = false, href = undefined, icon, name, newWindow = false, onClick, size = 'medium', stretch = false, type = 'button', variant, value, ...restProps }, ref) => {
    // Rebuild props to pass down, handling any conditionals...
    const props = {
        onClick,
        ref,
        size,
        stretch,
        variant,
        outerSpacing: useSpacing(restProps),
        ...pickComponentCommonProps(restProps),
        ...pickDataProps(restProps),
        ...pickAriaProps(restProps),
        ...(!disabled && { href }),
        ...(href
            ? {
                as: 'a',
                ...(newWindow && {
                    target: '_blank',
                    rel: 'noopener noreferrer',
                }),
            }
            : {
                disabled,
                name,
                type,
                value,
            }),
    };
    return (React.createElement(StyledButton, { ...props },
        icon && React.createElement(StyledIconContainer, null, icon),
        React.createElement(StyledButtonLabel, { size: size, icon: !!icon }, children),
        !icon && variant === 'text' && (React.createElement(StyledArrow, { xmlns: "http://www.w3.org/2000/svg", width: "8", height: "13", viewBox: "0 0 8 13" },
            React.createElement("path", { stroke: "currentColor", strokeWidth: "1px", fill: "none", d: "M1.5,1l5.485,5.504l-5.48,5.496" })))));
});
Button.propTypes = buttonPropTypes;
Button.displayName = 'Button';
//# sourceMappingURL=Button.js.map